import DashboardInfoBox from '@/views/home/components/DashboardInfoBox.vue';
import { RouteConfig } from 'vue-router';
import HomeDashboard from '@/views/home/Dashboard.vue';
import store from '@/store';

const routes: Array<RouteConfig> = [
  {
    path: '/home',
    name: 'home',
    component: HomeDashboard,
    beforeEnter: (_to, _from, next) => {
      store.dispatch('subscriptions/fetchSubscriptionFeed');
      store.dispatch('dashboard/fetchDashboardUsersList');
      store.dispatch('dashboard/fetchDashboardUserProfileStatus');
      next();
    },
    meta: {
      infoBox: {
        headline: 'infoBox.dashboard.headline',
        text: 'infoBox.dashboard.texts_USERTYPE',
        mobileComponent: DashboardInfoBox,
        enableTipNavigation: true,
      },
      auth: true,
      layout: 'full',
    },
  },
];

export default routes;
